import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import V2SettingsIframe from '@aware/common/v2-settings-iframe';
import { replaceCancelButtonAction } from './helpers';

const CreateNewTeam = () => {
  const history = useHistory();

  // This should just refresh the page
  const redirectFn = () => {
    history.push('create-new-team');
  };

  useEffect(() => {
    window.top.newTeamCallbackFn = newTeamId => {
      history.push('edit-my-teams', { newTeamId });
    };

    return () => delete window.top.newTeamCallbackFn;
  }, [history]);

  return (
    <V2SettingsIframe
      iframeSrc="/aware/?embed=1&detailsSrc=/Webmanager/addteamwiz.aspx"
      title="Create New Team"
      onLoadCallback={iframe => replaceCancelButtonAction({ iframe, redirectFn })}
    />
  );
};

export default CreateNewTeam;
